import theme from '../../base';

const textEditor = {
  background: theme.colors.neutrals.gray850,
  borderBackground: theme.colors.neutrals.gray700,
  foreground: theme.colors.neutrals.white,
  placeholder: theme.colors.neutrals.gray700,
  error: theme.colors.reds.red300,
};

export default textEditor;
